import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import RoomData from "../../../interfaces/robot/rooms/room-data";
import { useSharedActions, useSharedDispatch } from "../../../store/SharedProvider";
import ReadOnlyProtectedButton from "../../Inputs/ReadOnlyProtectedButton";
import ConfirmAbortDialog from "../../General/ConfirmAbortDialog";
import RestoreRoomDialog from "./RestoreRoomDialog";

const useStyles = makeStyles()(() => ({
  buttonLeftText: {
    justifyContent: "flex-start",
  },
}));

const TempRoomActions: React.FC<{ roomMetaInfo: RoomData }> = ({ roomMetaInfo }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const dispatch = useSharedDispatch();

  const { deleteRoomById } = useSharedActions();

  const [isDeleteRoomDialogOpen, setIsDeleteRoomDialogOpen] = useState(false);
  const [isRestoreRoomDialogOpen, setIsRestoreRoomDialogOpen] = useState(false);

  const deleteRoomClickHandler = () => {
    setIsDeleteRoomDialogOpen(true);
  };

  const deleteRoomDialogAbortHandler = () => {
    setIsDeleteRoomDialogOpen(false);
  };

  const deleteRoomDialogConfirmHandler = () => {
    dispatch(deleteRoomById({ roomId: roomMetaInfo.id, isTemporaryRoom: true }));
    setIsDeleteRoomDialogOpen(false);
  };

  const restoreRoomDialogClickHandler = () => {
    setIsRestoreRoomDialogOpen(true);
  };

  const restoreDialogAbortHandler = () => {
    setIsRestoreRoomDialogOpen(false);
  };

  const restoreDialogConfirmHandler = () => {
    setIsRestoreRoomDialogOpen(false);
  };

  return (
    <React.Fragment>
      <ReadOnlyProtectedButton
        id="restoreTempRoomButton"
        color="primary"
        size="small"
        fullWidth
        className={classes.buttonLeftText}
        onClick={restoreRoomDialogClickHandler}
      >
        {t("rooms-restore-room")}
      </ReadOnlyProtectedButton>
      <ReadOnlyProtectedButton
        id="deleteRoomButton"
        color="secondary"
        size="small"
        fullWidth
        className={classes.buttonLeftText}
        onClick={deleteRoomClickHandler}
      >
        {t("rooms-delete-room")}
      </ReadOnlyProtectedButton>

      <ConfirmAbortDialog
        isOpen={isDeleteRoomDialogOpen}
        title={t("rooms-delete-room")}
        description={t("rooms-delete-room-description")}
        confirmButtonText={t("button-confirm")}
        abortButtonText={t("button-abort")}
        onAbort={deleteRoomDialogAbortHandler}
        onConfirm={deleteRoomDialogConfirmHandler}
      />
      <RestoreRoomDialog
        isOpen={isRestoreRoomDialogOpen}
        roomMetaInfo={roomMetaInfo}
        onClose={restoreDialogAbortHandler}
        onSave={restoreDialogConfirmHandler}
      />
    </React.Fragment>
  );
};

export default TempRoomActions;
